<script>
  import { onMount } from 'svelte';
  import Container from './Container.svelte';
  import WaitingFor from './WaitingFor.svelte';

  export let signIn;
  let user, state = 'loading', err;

  onMount(() => {
    let searchParams = new window.URLSearchParams(window.location.search)

    let code = searchParams.get('code');

    if (code === null) {
      window.location.replace("https://github.com/login/oauth/authorize?client_id=bf7fba962dcf50df43e3")
    }
    signIn(code).then(u => {state='done'; user=u}).catch(e => {err = e.message})
  })

  // const storeSession = async () => {
  //   state = "loading";
  //   if (staySignedIn) {
  //     localStorage.setItem('telekinesisCloudSession', await user._session.sessionKey.exportKey());
  //   } else {
  //     localStorage.removeItem('telekinesisCloudSession');
  //   }
  // }
</script>

<Container>
  {#if state === 'loading'}
    <WaitingFor message='loading' />
  {:else if state == 'done'}
    {user}
  <!-- {:else if state == 'signup'}
    <h2>Welcome {action.user_id} to Interviewless</h2>
    <form class="pure-form pure-form-stacked">
          <label for="accept-tc" class='pure-checkbox'>
            <input type="checkbox" id="accept-tc" name='use-interviewless' bind:checked={approveTC}/>I have read and approve the<a href="/tc">Terms and Conditions</a>
          </label>
      <button 
        type="submit"
        style="background-color: var(--primary-color); color: white"
        class="pure-button pure-button-primary" 
        disabled={!approveTC} 
        on:click={async e => {e.preventDefault(); state = "loading"; await action.accept_tc()}}
      > Continue
      </button>
    </form> -->
  <!-- {:else if state == "store_session"}
    <label for="stay-signed-in" class='pure-checkbox'>
      <input type="checkbox" id="stay-signed-in" name='stay-signed-in' bind:checked={staySignedIn}/> Keep browser signed in
    </label>
    <button class="pure-button" on:click={approveStaySignedIn}>Continue</button> -->
  {:else if state == "timeout"}
    <h2>Login approval timed-out</h2>
  {:else if state == "error"}
    <h2>Login error</h2>
    <div style="padding: 20px; background-color: #ffa; color: #884;">
      {err}
    </div>
  {/if}
</Container>


<style>
  ul {
    padding-left: 0;
    list-style: none;
    font-size: 18px;
  }
</style>